export default __webpack_public_path__ + "static/cafe_36041-da68cd5c2ca9add91183f13e8b2e924e.png";